/** @format */

import React, { FunctionComponent as FC } from 'react';
export const VideoSlide: FC<{ url: string }> = ({ url }) => <div>{url}</div>;
